import { GradientButton, OutlinedButton } from '@src/components/reusable';
import { IconCheck, IconX } from '@tabler/icons-react';
import React from 'react';
import { Actions, Container, Description } from './styles';
import Modal from '@src/components/ui2/Modal';

interface AdderCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel: string;
  actionColor?: string;
}

const AdderCancelModal = (props: Readonly<AdderCancelModalProps>) => {
  const { isOpen, onClose, onConfirm, title, description, confirmLabel, cancelLabel, actionColor } = props;

  return (
    <Modal
      onClose={onClose}
      open={isOpen}
      title={title}
      width={402}
      slots={{
        Content: Container,
      }}
    >
      <Description>
        <p>{description}</p>
      </Description>

      <Actions>
        <OutlinedButton color={actionColor ?? ''} onClick={onClose}>
          <IconX size={20} />
          {cancelLabel}
        </OutlinedButton>

        <GradientButton fullWidth={false} actionColor={actionColor ?? ''} onClick={onConfirm}>
          <IconCheck size={20} />
          {confirmLabel}
        </GradientButton>
      </Actions>
    </Modal>
  );
};

export default AdderCancelModal;
